<template>
  <v-dialog
      v-model="dialog"
      max-width="600"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title class="title primary white--text font-weight-light px-4">
          {{ popupTitle }} Additional Information
          <v-spacer></v-spacer>
          <v-btn @click="closeDialog()" text color="white">
            <v-icon right>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-3 px-1">
          <p class="description">{{ descriptionContent }}</p>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
  props: [
    'dialog', 
    'popupTitle',
    'descriptionContent',

  ],
  data() {
    return {
    }
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog');
    }
  }
}
</script>